import React, { useContext, Fragment } from 'react'
import operatorContext from '../../../context/operator/operatorContext'

const TransactionItem = ({ transaction }) => {

    const OperatorContext = useContext(operatorContext);


    const { deleteTransaction } = OperatorContext;

    const {id, account_name, bank_name, account_number, account_type, date} = transaction;

    const onDelete = transaction_id => {
        deleteTransaction(transaction_id)
    }

    return (
        <Fragment>

        <td>{account_name}</td>
        <td>{bank_name}</td>
        <td>{account_number}</td>
        <td>{account_type}</td>
        <td>{date}</td>
        <td className="button-container">
            <button type="button" onClick={() => onDelete(id)}
                    className="btn button_style btn-inverse-danger waves-effect waves-light">DELETE
            </button>
        </td>


    </Fragment>
    )
}

export default TransactionItem
